/** Shared so callers outside the sidebar can address a pane's state without importing the pane. */
export const PUBLISHED_TREE_ID = "sidebar-published";
export const DRAFTS_TREE_ID = "sidebar-drafts";
export const DATA_SOURCES_TREE_ID = "sidebar-data-sources";
export const EXPORTS_TREE_ID = "sidebar-exports";
